import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import GenerujRozkladForm from "./components/GenerujRozkladForm";
import TrasyService from "../../../trasyConfig/trasy/TrasyService";
import DefinicjaGodzinyStartowejService from "../../definicjeGodzinStartowychjDlaTrasy/DefinicjaGodzinyStartowejService";
import DataFormat from "../../../../../utilities/DateAndTimeFormat";
import KalendarzDoDatyService from "../../kalendarze/przypisanieKalendarzaDoDaty/KalendarzDoDatyService";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopAlertOstrzezenie} from "../../../../../componentsTopsa/alerty/TopAlerts";
import KonfiguracjaService from "../../../../administracja/konfiguracja/KonfiguracjaService";

export default class GenerujRozkladPojedynczoContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy:[],
            godziny:[],
            alert_brak_zdefiniowanego_kalendarza: false,
            start:null,
            koniec:null,

        };
        this.getTrasy = this.getTrasy.bind(this)
        this.getGodziny = this.getGodziny.bind(this)
        this.szukajGodzin = this.szukajGodzin.bind(this)
        this.getKalendarzDoDaty = this.getKalendarzDoDaty.bind(this)
    }

    componentDidMount(){
        this.getTrasy();
        this.pobierzOkres()
    }

    pobierzOkres(){
        KonfiguracjaService.pobierzWartoscStartRozkladu().then(function (responseStart) {
            KonfiguracjaService.pobierzWartoscKoniecRozkladu().then(function (responseKoniec) {
                let start = responseStart.data;
                let koniec = responseKoniec.data;

                this.setState({
                    start: start,
                    koniec: koniec,
                })
            }.bind(this))
        }.bind(this))
    }

    getTrasy(){
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy:response.data.content})
        }.bind(this))
    }

    getKalendarzDoDaty(trasa,data){
        KalendarzDoDatyService.getDatyZKalendarzami(DataFormat.formatYYYYMMDD(data),DataFormat.formatYYYYMMDD(data)).then(function (response) {
            if(response.data.length>0){
                this.getGodziny(trasa.idTr,response.data[0].idRk)
            }
        }.bind(this))
    }

    getGodziny(trasa_id,kalendarz_id){

        this.setState({alert_brak_zdefiniowanego_kalendarza:false})
        DefinicjaGodzinyStartowejService.getGodzinyWTrasieIKalendarzu(trasa_id,kalendarz_id).then(function (response) {
            this.setState({godziny:response.data})
            if(response.data.length<=0){
                this.setState({alert_brak_zdefiniowanego_kalendarza:true})
            }
        }.bind(this))

    }

    szukajGodzin(trasa,data){
       this.getKalendarzDoDaty(trasa,data)
    }

    render() {

        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <GenerujRozkladForm trasy={this.state.trasy} handleSzukajGodzin={this.szukajGodzin} godziny={this.state.godziny}
                                            start={this.state.start} koniec={this.state.koniec}/>
                    </Col>
                    {/*<Col xs={12}>
                        <TopIf isTrue={this.state.alert_brak_zdefiniowanego_kalendarza}>
                            <TopAlertOstrzezenie text={'Brak zdefiniowanych godzin startowych dla w tej dacie dla wybranej trasy'}/>
                        </TopIf>
                        <div style={{height:'500px'}}></div>
                    </Col>*/}
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/generujRozkladPojedynczo/GenerujRozkladPojedynczoContainer.js